import { FileUnknownOutlined } from '@ant-design/icons';
import React from 'react';
import EmptyItems from './common/EmptyItems';

const EmptyOffers = () => (
  <EmptyItems
    Icon={FileUnknownOutlined}
    type="offre"
    description="à aucune offre active"
  />
);

export default EmptyOffers;
